// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__22SQr","top":"styles_top__LbSBD","left":"styles_left__Cu91M","description":"styles_description__J3c2L"};